// extracted by mini-css-extract-plugin
module.exports = {"container":"wedding_venues_container__VXqxF"};